import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import MapaPickerComponent from './Zonas/MapaPickerComponent';
import ZonasFormComponent from './Zonas/ZonasFormComponent';
import ZonasListComponent from './Zonas/ZonasListComponent';


function PanelZonas(props) {

    const DefaultLocation = { lat: 17.0669, lng: -96.7203 };
    const [defaultLocation, setDefaultLocation] = useState(DefaultLocation);
    const [location, setLocation] = useState(defaultLocation);

    return (
        <Fragment><br />
            <div className='container'>
                <div className='row'>
                    <ZonasListComponent></ZonasListComponent>
                    <br/><br />
                    <hr/>
                    <div style={{display: false ? 'block' : 'none' }}>
                        <MapaPickerComponent defaultLocation={defaultLocation} location={location} setLocation={setLocation} setDefaultLocation={setDefaultLocation} />
                    </div>
                </div>
            </div>


        </Fragment>
    );
};


export default withRouter(PanelZonas)
